import { Link } from "react-router-dom";
import {
  faArrowRight,
  faBath,
  faBed,
  faLocationDot,
  faRulerCombined,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ListingCard({ property, image }) {
  const isResidential =
    property.PropertyType?.toLowerCase().includes("residential");

  return (
    <Link
      to={`/listing/${property.ListingKey}`}
      className="group block h-full"
    >
      <article className="overflow-hidden rounded-xl border border-harbour-border bg-harbour-surface transition-all duration-500 hover:-translate-y-1 hover:shadow-xl">

        {/* Image */}
        <div className="relative overflow-hidden">
          <img
            // src={image?.MediaURL ?? "/placeholder.jpg"}
            src={image}
            alt={property.UnparsedAddress ?? "Property"}
            className="h-56 w-full object-cover transition duration-700 group-hover:scale-105"
          />

          {/* Type Badge */}
          <div className="absolute right-4 top-4 rounded-full bg-white/95 px-3 py-1.5 backdrop-blur">
            <p className="text-[10px] uppercase tracking-[0.25em] text-harbour-navy">
              {property.PropertyType}
            </p>
          </div>

          {/* Price */}
          <div className="absolute bottom-0 left-0">
            <div className="bg-harbour-navy px-5 py-3 shadow-lg">
              <p className="font-heading text-2xl leading-none text-white">
                ${property.ListPrice?.toLocaleString()}
              </p>
            </div>
          </div>
        </div>


        {/* Content */}
        <div className="px-5 pb-4 pt-5">
          {/* Location */}
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-harbour-blue">
            <FontAwesomeIcon
              icon={faLocationDot}
            />
            <span className="truncate">
              {property.City ||
                property.CityRegion ||
                property.CrossStreet ||
                "Location"}
            </span>
          </div>

          {/* Address */}
          <h2 className="mt-2 truncate font-heading text-2xl leading-tight text-harbour-navy">
            {property.StreetNumber}{" "}
            {property.StreetName}{" "}
            {property.StreetSuffix}
          </h2>

          <div className="my-3 h-px bg-harbour-border" />

          {/* Features */}
          <div className="grid grid-cols-3 gap-2">
            {isResidential ? (
              <>
                <div className="text-center">
                  <FontAwesomeIcon
                    icon={faBed}
                    className="text-sm text-harbour-accent"
                  />

                  <p className="mt-1 text-base font-medium text-harbour-text">
                    {property.BedroomsTotal ??
                      property.BedroomsTotalInteger ??
                      "--"}
                  </p>

                  <span className="text-[9px] uppercase tracking-[0.2em] text-harbour-muted">
                    Beds
                  </span>
                </div>

                <div className="text-center">
                  <FontAwesomeIcon
                    icon={faBath}
                    className="text-sm text-harbour-accent"
                  />

                  <p className="mt-1 text-base font-medium text-harbour-text">
                    {property.BathroomsTotalInteger ?? "--"}
                  </p>

                  <span className="text-[9px] uppercase tracking-[0.2em] text-harbour-muted">
                    Baths
                  </span>

                </div>

              </>
            ) : (

              <div className="col-span-2 flex items-center justify-center gap-2">

                <FontAwesomeIcon
                  icon={faStore}
                  className="text-harbour-accent"
                />

                <span className="truncate text-xs text-harbour-text">
                  {property.PropertySubType ?? "Commercial"}
                </span>

              </div>

            )}



            <div className="text-center">
              <FontAwesomeIcon
                icon={faRulerCombined}
                className="text-sm text-harbour-accent"
              />

              <p className="mt-1 text-base font-medium text-harbour-text">
                {property.LivingAreaRange ||
                  property.BuildingAreaTotal ||
                  "--"}
              </p>

              <span className="text-[9px] uppercase tracking-[0.2em] text-harbour-muted">
                Sq Ft
              </span>
            </div>
          </div>


          {/* Footer */}
          <div className="mt-4 flex items-center justify-between border-t border-harbour-border pt-3">
            <span className="text-[10px] uppercase tracking-[0.3em] text-harbour-blue">
              View Property
            </span>

            <div className="flex h-9 w-9 items-center justify-center rounded-full border border-harbour-border transition-all duration-300 group-hover:border-harbour-accent group-hover:bg-harbour-accent">
              <FontAwesomeIcon
                icon={faArrowRight}
                className="text-sm text-harbour-navy transition-transform duration-300 group-hover:translate-x-1"
              />
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
}
